module.exports = __webpack_public_path__ + "static/media/g2slogo.c07d87ca.png";